import React, { useState, useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';
import Pagination from 'components/Misc/Pagination';

import Search from 'containers/Administrator/Users/Profile/Teacher/Students/Search';
import Student from 'containers/Administrator/Users/Profile/Teacher/Students/Student';

const Students = ({ tab, setTab }) => {
	// Cache current object's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Cache search data
	const [search, setSearch] = useState({
		fullName: '',
		page: 1
	});

	// Store request parameters
	const parameters = useMemo(() => ({
		related: 'teachers:students',
		// 'student.name': `%${search.fullName}%`,
	}), [search]);

	// Store requested courses
	const [[students, progress], collect] = useCollect(`users/${id}`, parameters);

	// Handles search field's onChange event
	// @event: object | onChange event
	const onSearch = ({ name, value }) => {
		// Special case for page change
		if (name === 'page') return setSearch(prev => ({
			...prev,
			[name]: value
		}));

		setSearch(prev => ({
			...prev,
			[name]: value,
			page: 1
		}));
	};

	// Collect user on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<>
			{/* Search container */}
			<Search search={search} onChange={onSearch} />

			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Show nothing found */}
			<Nothing visible={!students?.length && !progress} />

			{/* Show students if results collected */}
			<Show if={students?.length && !progress}>
				<div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
					{students?.map(entry =>
						<Student key={entry.id} entry={entry} />
					)}
				</div>
			</Show>
		</>
	);
};

export default Students;